export default __webpack_public_path__ + "static/media/mv.b8ee9595.svg";